import './index.scss'
import {motion} from "framer-motion"
import { FaMinus } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";

type FaqItemsProps = {
    item: {
        id: string 
        title: string 
        ans: string 
        isOpen: boolean
    }
    checkIsOpen: (id:string) => void
}


const FaqItems = (props:FaqItemsProps) => {

    const {item, checkIsOpen} = props 
    const {id, title, ans, isOpen} = item

    const toggleFaq = () => {
        checkIsOpen(id)
    }

    const child = {
        visible:{
            y:0,
            opacity:1,
            transition:{
                duration:1, 
                type:"tween",
                ease:"easeIn"
            }
        },
        hidden:{
            y:50,
            opacity:0
        }
    }

    return(
        <>
        <motion.div style={{cursor:"pointer"}} variants={child} className='d-flex flex-row justify-content-between align-items-center w-100 mt-3 m-b--10' onClick={toggleFaq}>
            <p className={isOpen?'p2-size font-weight-4 font-1 col-secondary':'p2-size font-weight-4 font-1 col-black'}>{title}</p>
            {isOpen?<FaMinus fill="#F45600" />:<FaPlus fill="#F45600" width={14} height={14}/>}
        </motion.div>
        <motion.div initial={{y:-30, opacity:0}} animate={{y:isOpen?0:-30, opacity:isOpen?1:0}} transition={{duration:0.5,type:"tween"}} style={{height:isOpen?"auto":"0px"}} className='text-12 font light-blue p-3'>{ans}</motion.div>
        <motion.div variants={child} className='border-btm w-100'></motion.div>
        </>
    )
}

export default FaqItems